(function () {
	'use strict';

	angular.module('app.core')
		.service('chartService', chartService);

	chartService.$inject = [];

	function chartService() {
		var charts = [];
		var service = {
			getChartsForPrint: getChartsForPrint,
			addChartForPrint: addChartForPrint,
			clearChartsForPrint: clearChartsForPrint
		};

		return service;

		function getChartsForPrint() {
			return charts;
		}

		function addChartForPrint(chart) {
			charts.push(chart);
		}

		function clearChartsForPrint() {
			charts = [];
		}

	}
})();
